<template>
	<div>
		<page-header :title="title"></page-header>
		<form @submit.prevent="gravar">
			<div class="modal-body">
				<div class="form-horizontal">
					<vue-element-loading :active="isActive" spinner="bar-fade-scale"
						color="#428BCA"></vue-element-loading>
					
					<input-form-text textInput="Prefeito" :required="true" v-model="form.title"
						:value="form.title"></input-form-text>
						<div class="form-group"><label class="col-sm-3 control-label no-padding-right" for="mandato"> Mandato </label>
						<div class="col-sm-9">
							<the-mask class="col-xs-10 col-sm-3" type="text" name="mandato" :mask="['####/####']"
								v-model="form.mandato" placeholder="Mandato" required="" :masked="true"></the-mask>
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right"></label>
						<div class="col-sm-5">
							<file-upload v-if="!allImages.length" ref="fupload" :url="'/v1/prefeitos/upload'" :id="null"
								:label="'PNG, JPG, GIF até 10 MB'" :multiple="false" width="800"></file-upload>
							<items-edit v-else :files="allImages"
								url="/v1/prefeitos/upload" id="id" width="800"></items-edit>
						</div>
					</div>
					<div class="form-group">
						<select-form v-model="form.active" :value="form.active" name="Ativo" url="/arquivos" id="id"
							titulo="nome" layout="true" optionText="Selecione" required="true"></select-form>
					</div>
				</div>
			</div>
			<footer-button :disabled="isActiveBtn"></footer-button>
		</form>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VueElementLoading from 'vue-element-loading'
import PageHeader from '@/components/PageHeader'
import InputFormText from '@/components/form/InputForm'
import FooterButton from '@/components/form/FooterButton'
import SelectForm from '@/components/form/SelectForm'
import Permission from '@/mixins/Permission'
import req from '@/components/request'
import { sucesso, erro } from '@/components/Message'
import fileUpload from '@/components/form/file-upload/Index'
import ItemsEdit from '@/components/form/file-upload/ItemsEdit'
import { TheMask } from 'vue-the-mask'

export default {
	components: {
		PageHeader,
		InputFormText,
		FooterButton,
		SelectForm,
		VueElementLoading,
		fileUpload,
		ItemsEdit,
		TheMask
	},
	mixins: [Permission],
	computed: {
		...mapGetters([
			'user'
		])
	},
	data() {
		return {
			title: 'Prefeitos',
			form: {
				title: '',
				mandato: '',
				active: '1',
			},
			allImages: [],
			isActiveBtn: false,
			isActive: false
		}
	},
	methods: {
		...mapActions([
			'getLogsTotal'
		]),
		async gravar() {
			this.isActive = true
			this.isActiveBtn = true
			const body = this.form
			//this.setVersion()
			if (this.$route.params.id) {
				let resp = await req(`/v1/prefeitos/${this.$route.params.id}`, 'put', body).catch(response => {
					'error: ' + response
					erro()
				})
				if (!this.allImages.length) {
					this.isActive = false
					const tb = this.$refs.fupload.$children.filter(i => i.$refs.tb)
					const m = tb[0]
					await m.uploadAll(resp)
				}
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/site/prefeitos')
			} else {
				let resp = await req('/v1/prefeitos', 'post', body).catch(response => {
					'error: ' + response
					erro()
				})
				this.isActive = false
				const tb = this.$refs.fupload.$children.filter(i => i.$refs.tb)
				const m = tb[0]
				await m.uploadAll(resp)
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/site/prefeitos')
			}
			this.isActiveBtn = false
		},
		async setVersion() {
			const dados = await req('/versao/1', 'put', {
				title: Date.now()
			})
			dados
		},
		async getDados() {
			const resp = await req(`/v1/prefeitos/${this.$route.params.id}`).catch(response => {
				'error: ' + response
				erro()
			})
			this.form.active = resp.active
			this.form.title = resp.title
			this.form.mandato = resp.mandato
			this.allImages = resp.foto ? [{ id: this.$route.params.id, images: resp.foto }] : ''
			this.isActive = false
		},
		verifPermissao() {
			if (this.$route.params.id) {
				if (!this.ACTION.e) {
					this.$router.push('/erro')
				}
			} else {
				if (!this.ACTION.c) {
					this.$router.push('/erro')
				}
			}
		}
	},
	mounted() {
		this.verifPermissao()
		if (this.$route.params.id) {
			this.isActive = true
			this.getDados()
		}
	}
}
</script>

<style lang="stylus" scoped>

</style>
